import type { RemoveUser } from '@fourthwall/services/dist/ShopUsersApiClient'
import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { useMutation } from '@tanstack/react-query'

export const useUserRemoveMutation = () => {
  const userRemoveMutation = useMutation({
    mutationFn: async (variables: RemoveUser['Payload']) => {
      const { data } = await ShopUsersApiClient.removeUser(variables)

      return data
    },
  })

  return { userRemoveMutation }
}
